/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSecretarySchema
 */
export interface CreateSecretarySchema {
    /**
     * 
     * @type {string}
     * @memberof CreateSecretarySchema
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSecretarySchema
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateSecretarySchema interface.
 */
export function instanceOfCreateSecretarySchema(value: object): boolean {
    return true;
}

export function CreateSecretarySchemaFromJSON(json: any): CreateSecretarySchema {
    return CreateSecretarySchemaFromJSONTyped(json, false);
}

export function CreateSecretarySchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSecretarySchema {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CreateSecretarySchemaToJSON(value?: CreateSecretarySchema | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'phone_number': value['phoneNumber'],
        'name': value['name'],
    };
}

